// extracted by mini-css-extract-plugin
module.exports = {"switch":"ThemeSwitcher-module--switch--1chZ5","sunIcon":"ThemeSwitcher-module--sunIcon--30uYL","moonIcon":"ThemeSwitcher-module--moonIcon--1M2sQ"};